/** Как часто открытая вкладка спрашивает сервер, не вышла ли новая версия приложения. */
export const UPDATE_CHECK_INTERVAL_MS = 5 * 60 * 1000;

interface UpdatableRegistration {
  update: () => Promise<unknown>;
}

interface Environment {
  setInterval: (handler: () => void, ms: number) => number;
  clearInterval: (id: number) => void;
  document: Pick<Document, 'addEventListener' | 'removeEventListener' | 'visibilityState'>;
  navigator: Pick<Navigator, 'onLine'>;
}

/**
 * Сервис-воркер сам проверяет обновление только при переходе по ссылке, а вкладка владельца может
 * стоять открытой днями. После выкладки с изменённым контрактом API (например, количества строками)
 * такая вкладка продолжала бы работать на старом коде, поэтому обновление проверяется раз в
 * `UPDATE_CHECK_INTERVAL_MS` и при возврате на вкладку. Нашлась новая версия — `useRegisterSW`
 * покажет «Доступно обновление». Возвращает функцию отмены.
 */
export function schedulePeriodicUpdate(
  registration: UpdatableRegistration,
  env: Environment = { setInterval: (h, ms) => window.setInterval(h, ms), clearInterval: (id) => window.clearInterval(id), document, navigator },
): () => void {
  const check = (): void => {
    if (!env.navigator.onLine) return;
    registration.update().catch(() => undefined); // нет сети или сервер недоступен — повторим в следующий раз
  };
  const onVisible = (): void => {
    if (env.document.visibilityState === 'visible') check();
  };
  const timer = env.setInterval(check, UPDATE_CHECK_INTERVAL_MS);
  env.document.addEventListener('visibilitychange', onVisible);
  return () => {
    env.clearInterval(timer);
    env.document.removeEventListener('visibilitychange', onVisible);
  };
}
